import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { CalendarDays, Store } from 'lucide-react';
import { useAuth } from 'context/auth/Auth';
import paths from 'routes/paths';
import breakpoints from 'theme/breakpoints';
import {
    Section,
    SectionInner,
    Eyebrow,
    SectionTitle,
    SectionSubtitle,
    PrimaryButton,
    campaign,
} from './shared';

export default function AffiliateSection() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuth } = useAuth();

    function goToAffiliate() {
        if (isAuth) {
            navigate(paths.user.affiliate);
            return;
        }

        navigate({
            pathname: paths.login,
            search: new URLSearchParams({ redirectTo: paths.user.affiliate }).toString(),
        });
    }

    return (
        <Section>
            <SectionInner>
                <Layout>
                    <TextCol>
                        <Eyebrow>Novidade da fase</Eyebrow>
                        <SectionTitle>Chama a galera pra Whizr e ganha por isso</SectionTitle>
                        <SectionSubtitle>
                            Todo produtor e estabelecimento já tem um link de indicação só seu.
                            Manda pra quem você conhece e acompanha as comissões caindo direto
                            no seu painel.
                        </SectionSubtitle>

                        <PrimaryButton onClick={goToAffiliate}>
                            Gerar meu link de indicação
                        </PrimaryButton>
                    </TextCol>

                    <RulesCol>
                        <RuleCard>
                            <RuleIconBox>
                                <CalendarDays size={18} color={campaign.purple} />
                            </RuleIconBox>
                            <RuleTextBox>
                                <strong>Produtor indicado</strong>
                                <span>1% sobre os 3 primeiros eventos, dentro de 1 ano da aprovação.</span>
                            </RuleTextBox>
                        </RuleCard>

                        <RuleCard>
                            <RuleIconBox>
                                <Store size={18} color={campaign.purple} />
                            </RuleIconBox>
                            <RuleTextBox>
                                <strong>Estabelecimento indicado</strong>
                                <span>30% uma única vez, sobre a primeira assinatura de plano, em até 3 meses da aprovação.</span>
                            </RuleTextBox>
                        </RuleCard>

                        <RuleFootnote>
                            As comissões são apuradas pelo time comercial dentro do prazo de cada indicação.
                        </RuleFootnote>
                    </RulesCol>
                </Layout>
            </SectionInner>
        </Section>
    );
}

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        align-items: center;
        gap: 56px;
    }
`;

const TextCol = styled.div`
    flex: 1;
`;

const RulesCol = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const RuleCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    background: #fff;
    border: 1px solid ${campaign.purple}22;
    border-radius: 16px;
    padding: 18px 20px;
`;

const RuleIconBox = styled.div`
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: ${campaign.purple}14;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const RuleTextBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 14.5px;
    line-height: 1.45;

    strong {
        font-size: 15.5px;
    }
`;

const RuleFootnote = styled.p`
    font-size: 12.5px;
    color: #8a8a8a;
    margin: 4px 4px 0;
`;
